import { render, staticRenderFns } from "./SedesLista.vue?vue&type=template&id=76dd6e0d&scoped=true&"
import script from "./SedesLista.vue?vue&type=script&lang=js&"
export * from "./SedesLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dd6e0d",
  null
  
)

export default component.exports